import { GetOrgId } from "../../utility";

export const isPayBillsEnabled = (user) => {
  const whitelistedOrgIds = window.__ENV__.PAY_BILLS_WHITELIST_ORG_IDS?.split(",") || [];

  return user?.isAdmin && whitelistedOrgIds.includes(GetOrgId());
};
